import { Component } from "react";
import Box from '@mui/material/Box';
import ProfileHeader from "../../../components/ProfileHeader";
import { getSessionStorage } from "../../../utils/StorageUtil";
import { TOKEN_SO_KEY } from "../../../utils/accountUtils";
import ProfileBottomNav from "../../../components/ProfileBottomNav";
import DomainSearch from "./DomainSearch";
import RentNewUnit from "./RentNewUnit";
import { Trans } from 'react-i18next';
import SearchVehiclesContext from "./SearchVehiclesContext";
import NotFoundUnitDetail from "./notFoundUnitDialog";

type State = {
  refresh: boolean
}

export default class extends Component<any, State> {

  constructor(props: any) {
    super(props)
    this.state = {refresh: false}
  }

  componentDidMount() {
    document.body.classList.add("grey-background");
  }

  componentWillUnmount() {
    window.location.reload();
    document.body.classList.remove("grey-background");
  }

  render() {
    return (
      <SearchVehiclesContext.Consumer>
        { context => {
          context.refresh = () => this.setState({refresh: !this.state.refresh})
          return (
            <Box>
              <ProfileHeader></ProfileHeader>
              <Box sx={{margin: '0 4%'}}>
                <Box className="search-vehicles-title"><Trans i18nKey={`screens.searchVehicles.title`}/></Box>
                <DomainSearch/>
                <RentNewUnit/>
              </Box>
              { getSessionStorage(TOKEN_SO_KEY) !== null && <ProfileBottomNav goBack={true}/>}
              <NotFoundUnitDetail/>
            </Box>
          )
        }}
      </SearchVehiclesContext.Consumer>
    );
  }
 
}